import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  AppBar, Container, Toolbar, Dialog, Button, Card, CardContent, Drawer, Checkbox,
  FormControl, Menu, MenuItem, Box, IconButton,
  InputBase, CircularProgress, Typography, DialogTitle, DialogContent,
  Radio, RadioGroup, FormControlLabel
} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";

import SignInModal from '../Components/SignInModal.js';
import DonateModal from '../Components/DonateModal.js';
import NewsletterModal from '../Components/NewsletterModal.js';
import CreateEventModal from '../Components/CreateEventModal.js';
import AdComponent from '../Components/AddComponent.js';

import { getEventsByDate, convertToAmPm } from '../controller.tsx';
import { useUser } from '../Context/UserContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CompanyPage from './CompanyPage.js';
import CompanySearch from '../Components/CompanySearch.js'; // NEW import

const Search = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: "#f1f3f4",
  padding: "6px 12px",
  borderRadius: "20px",
  width: "100%",
  maxWidth: "500px",
  color: "#000", // This sets the font color to black
}));

const SkeletonWebPage = () => {
  const { userID, setUserID } = useUser();
  dayjs.extend(utc);

  const today = useMemo(() => dayjs(), []);
  const [date, setDate] = useState(today);
  const [aDate, setADate] = useState(today.format('YYYY-MM-DD'));
  const [anchorEl, setAnchorEl] = useState(null);

  const [compSearch, setCompSearch] = useState('');
  //  const [categoryFilter, setCategoryFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [dateEvents, setDateEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);

  const [isSortBy, setIsSortBy] = useState(false);
  const [sortBy, setSortBy] = useState('default');

  const [isEventModal, setIsEventModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState({});
  const [isCompOnlyChecked, setIsCompOnlyChecked] = useState(false);

  const [isSignIn, setIsSignIn] = useState(false);
  const [isDonate, setIsDonate] = useState(false);
  const [isNewsletter, setIsNewsletter] = useState(false);
  const [isCreateEvent, setIsCreateEvent] = useState(false);

//  const [userLocation, setUserLocation] = useState({ lat: null, lon: null });

//  console.log(aDate);
  const loadDateEvents = useCallback(async () => {
    setLoading(true);
    const events = await getEventsByDate(aDate);
    setDateEvents(events);
    setLoading(false);
  }, [aDate]);

//  useEffect(() => {
//    navigator.geolocation.getCurrentPosition(
//      (pos) => setUserLocation({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
//      (err) => console.error(err)
//    );
//  }, []);
//

  useEffect(() => {
    loadDateEvents();
  }, [loadDateEvents]);

  useEffect(() => {
    setFilteredEvents(dateEvents.filter(event =>
      event.name.toLowerCase().includes(compSearch.toLowerCase())
    ));
  }, [dateEvents, compSearch]);


// TODO: NEED TO TEST. distance feature (chatgpt)
//  const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
//    const R = 6371; // Radius of the earth in km
//    const dLat = (lat2 - lat1) * Math.PI / 180;
//    const dLon = (lon2 - lon1) * Math.PI / 180;
//    const a =
//      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//      Math.cos(lat1 * Math.PI / 180) *
//      Math.cos(lat2 * Math.PI / 180) *
//      Math.sin(dLon / 2) * Math.sin(dLon / 2);
//    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//    return R * c; // Distance in km
//  }

  const handleDateChange = (newDate) => {
    if (newDate) {
      setDate(newDate);
      setADate(newDate.format('YYYY-MM-DD'));
    }
  };

  const handleSortBy = () => {
       // todo: case switch
    if (sortBy === 'default') {
      filteredEvents.sort((a, b) => a.id - b.id);
    } else if (sortBy === 'alpha') {
      filteredEvents.sort((a, b) => a.name.localeCompare(b.name));
    }
    else if (sortBy === 'distance') {
      // todo calculate distance given address of location and location of user
    }
    else if (sortBy === 'location') {
      filteredEvents.sort((a, b) => a.location.localeCompare(b.location));
    }
    setIsSortBy(false);
  }

  const handleIsOnlyCompany = (e) => {
    const checked = e.target.checked
    setIsCompOnlyChecked(checked);

    if (checked) {
      setFilteredEvents(filteredEvents.filter(event => event.cID?.length > 0));
    } else {
      setFilteredEvents(dateEvents.filter(event => event.name.toLowerCase().includes(compSearch.toLowerCase())));
    }
  }

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // The main content (keeps local state scope)
  const MainWebContent = () => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <AppBar position="static" color="primary" elevation={2}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <Button onClick={handleMenuClick} variant="contained" sx={{ backgroundColor: 'black' }}>Actions</Button>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
            <MenuItem onClick={() => {
              setIsDonate(true);
              setAnchorEl(null);
            }}>Donate</MenuItem>
            <MenuItem onClick={() => {
              setIsNewsletter(true);
              setAnchorEl(null);
            }}>Register to post events</MenuItem>
            {!userID && (
              <MenuItem onClick={() => {
                setIsSignIn(true);
                setAnchorEl(null);
              }}>Sign in</MenuItem>
            )}
            {userID && (
              <MenuItem onClick={() => {
                setUserID(null)
                setAnchorEl(null);
              }}>Logout</MenuItem>
            )}
          </Menu>
          <FormControl>
            <FormControlLabel
              control={<Checkbox checked={isCompOnlyChecked} onChange={handleIsOnlyCompany} />}
              label={"Show registered company events"}
              labelPlacement="end"
            />
          </FormControl>
          <Button onClick={() => setIsSortBy(true)} variant="contained" sx={{ backgroundColor: 'black' }}>Sort By</Button>
          {userID && <Button onClick={() => setIsCreateEvent(true)} variant="contained" sx={{ backgroundColor: 'black' }}>Create event</Button>}

        <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
            <CompanySearch placeholder="Search companies..." />
        </Box>

          <Dialog open={isSortBy} onClose={() => setIsSortBy(false)}>
            <DialogTitle>Sort By</DialogTitle>
            <DialogContent>
              <FormControl component="fieldset">
                <RadioGroup value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                  <FormControlLabel value="default" control={<Radio />} label="Default" />
                  <FormControlLabel value="alpha" control={<Radio />} label="Alphabetical" />
                  <FormControlLabel value="location" control={<Radio />} label="Location" />
                </RadioGroup>
              </FormControl>
              <Button variant="contained" sx={{ mt: 2 }} onClick={handleSortBy}>Sort</Button>
            </DialogContent>
          </Dialog>

          <Search>
            <SearchIcon sx={{ mr: 1 }} />
            <InputBase placeholder="Search events..." fullWidth sx={{ color: "#000" }}
              value={compSearch}
              onChange={(e) => setCompSearch(e.target.value)}
            />
          </Search>
          <DatePicker
            value={date}
            onChange={handleDateChange}
            slotProps={{
              textField: {
                variant: 'outlined',
                sx: { backgroundColor: 'background.paper', borderRadius: 2, '& .MuiInputBase-input': { color: 'text.primary' }, },
              },
            }}
          />
        </Toolbar>
      </AppBar>
      {/* AdComponent adSlot="5951337236" / */}
      <Container sx={{ minHeight: '100vh', p: 2 }}>
        {loading ? (<Box display="flex" justifyContent="center" mt={4}> <CircularProgress /></Box>) : (
          filteredEvents.map((event, index) => (
            <React.Fragment key={index}>
              <Card
                key={event.id}
                sx={{ mb: 2, p: 2, borderRadius: 2, boxShadow: 2, cursor: 'pointer', '&:hover': { boxShadow: 4 }, }}
                onClick={() => {
                  setSelectedEvent(event);
                  setIsEventModal(true);
                }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Box sx={{ width: 80, height: 80, overflow: 'hidden', borderRadius: 2, flexShrink: 0 }}>
                      <img src={event.logo} alt="Event"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    </Box>
                    <Box sx={{ pl: 3 }}>
                      <Typography variant="h6" fontWeight="bold">{event.name}</Typography>
                      <Typography variant="body2" color="text.secondary">{event.location}</Typography>
                      <Typography variant="body2" color="text.secondary">{convertToAmPm(event.time_string)}</Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
              {(index + 1) % 3 === 0 && (
                <Box my={3}>
                  <AdComponent
                    adSlot="8442587441"
                    adFormat="fluid"
                    layoutKey="-fh-1l+3h-vz+1bp"
                  />
                </Box>
              )}
            </React.Fragment>
          ))
        )}
      </Container>

      <Drawer
        anchor="right"
        open={isEventModal}
        onClose={() => setIsEventModal(false)}
        ModalProps={{ keepMounted: true }}
        BackdropProps={{ sx: { backgroundColor: "transparent" } }}
        PaperProps={{ sx: { width: 500, borderRadius: 2, m: 2, p: 2, boxShadow: 3, }, }}
      >
        <Box p={2}>
          <IconButton onClick={() => setIsEventModal(false)}><CloseIcon /></IconButton>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <img
              src={selectedEvent?.logo}
              alt="Event Logo"
              style={{ width: '100%', maxWidth: 400, height: 200, objectFit: 'cover', borderRadius: '8px', }}
            />
          </Box>

          <Typography variant="h6" fontWeight="bold">{selectedEvent?.name}</Typography>
          <Typography>{selectedEvent?.description || "No description available"}</Typography>
          <Box sx={{ my: 2, cursor: 'pointer' }}
            onClick={() => {
              window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(selectedEvent?.location)}`, '_blank');
            }}
          >
            <Typography variant="body2" color="text.secondary">{selectedEvent?.location}</Typography>
            <Typography variant="body2" sx={{ fontStyle: 'italic' }}>{selectedEvent?.address}</Typography>
          </Box>
          <Typography>{convertToAmPm(selectedEvent?.time_string)}</Typography>

          <a href={selectedEvent?.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <Button variant="text" color="secondary"> {selectedEvent?.link}</Button>
          </a>
        </Box>
      </Drawer>

      <SignInModal isOpen={isSignIn} setIsOpen={setIsSignIn} />
      <DonateModal isOpen={isDonate} setIsOpen={setIsDonate} />
      <NewsletterModal isOpen={isNewsletter} setIsOpen={setIsNewsletter} />
      <CreateEventModal isOpen={isCreateEvent} setIsOpen={setIsCreateEvent} />
    </LocalizationProvider>
  );

  // Router for web/desktop. We wrap the main content and the CompanyPage in a Router,
  // because App.js only renders SkeletonWebPage (no top-level Router) for desktop.
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainWebContent />} />
        <Route path="/company/:id" element={<CompanyPage />} />
      </Routes>
    </Router>
  );
};

export default SkeletonWebPage;